export default __webpack_public_path__ + "static/media/Armbands of the Judgment Bolt.e19b7d0a.jpg";